import styled from 'styled-components';

export const StyledImage = styled.img`
  border-radius: ${props => props.theme.borderRadii.small};
  height: 64px;
  width: 96px;
`;
